export const getValueInRange = (min: number, max: number, value: number): number => Math.max(min, Math.min(max, value));
